import {Deserializable} from '../deserializable';
import {Staffs} from '../staff/staffs';


export  class VanBanDenXL implements Deserializable
{
  public  id: number;
  public  maVB: number;
  public  maNguoiXuLy: number;
  public  maNguoiChuTri: number;
  public  ghiChu: string;
  public  ketQua: string;
  public  maTrangThaiXL: number;
  public  noidungYCXL: string;
  public  xeploaiDG: number;
  public  maNguoiDG: number;
  public  xem: number;
  public  tuHoanThanh: number;
  public  usersWrite: string;
  public  soLanDoc: number;
  public  thoiGianXemLanDau: string;
  public  thoiGianXemLanCuoi: string;
  public  capXuLy: number;
  public  maNguoiGiaoTiep: number;
  public  ndXuLyTiep: string;
  public  theoDoiCap2: number;
  public   nguoiXuLy: Staffs;
  public   nguoiGiaoTiep: Staffs;
  public   nguoiChuTri: Staffs;
  deserialize(input: any): this {
    Object.assign(this, input);
    this.nguoiXuLy= input.nguoiXuLy != null ?  new Staffs().deserialize(input.nguoiXuLy): null;
    this.nguoiGiaoTiep= input.nguoiGiaoTiep != null ? new Staffs().deserialize(input.nguoiGiaoTiep): null;
    this.nguoiChuTri= input.nguoiChuTri != null ? new Staffs().deserialize(input.nguoiChuTri): null;
    return this;
  }
}
